import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Spinner } from "spot-component-library/lib/components/basic/spinner/Spinner";
import RateAgreementApp from "./main/RateAgreementApp";
import { TenantProvider } from "./main/contexts/TenantContext";
import { ActiveRateAgreement } from "./main/modules/activeRateAgreement/ActiveRateAgreement";
import { Landing } from "./main/modules/landingPage/landing";
import { RateAgreementTeaser } from "./main/modules/rateAgreementTeaser/RateAgreementTeaser";
import "./resources/styles/index.css";
import "./i18n";

const spinner = <Spinner isLoading={true} type="page" />;

const isEnabled = (): boolean => {
    // @ts-ignore inject from webpack build
    return false;
};

const root = document.getElementById("root");
if (root) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={spinner}>
                <TenantProvider>
                    <RateAgreementApp rateAgreementReminderEnabled={isEnabled()} />
                </TenantProvider>
            </Suspense>
        </React.StrictMode>,
        document.getElementById("root")
    );
}

const landing = document.getElementById("landing");
if (landing) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={spinner}>
                <TenantProvider>
                    <Landing />
                </TenantProvider>
            </Suspense>
        </React.StrictMode>,
        landing
    );
}

const rateAgreementTeaser = document.getElementById("rateagreement-teaser");
if (rateAgreementTeaser) {
    const titleText = rateAgreementTeaser?.getAttribute("data-teaser-text");
    const infoText = rateAgreementTeaser?.getAttribute("data-text");
    const campaignName = rateAgreementTeaser.getAttribute("data-campaign");
    const buttonText = rateAgreementTeaser.getAttribute("data-button");

    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={spinner}>
                <RateAgreementTeaser titleText={titleText} infoText={infoText} campaign={campaignName} buttonText={buttonText} />
            </Suspense>
        </React.StrictMode>,
        rateAgreementTeaser
    );
}

const activeRateAgreement = document.getElementById("active-rate-agreement");
if (activeRateAgreement) {
    ReactDOM.render(
        <React.StrictMode>
            <Suspense fallback={spinner}>
                <TenantProvider>
                    <ActiveRateAgreement />
                </TenantProvider>
            </Suspense>
        </React.StrictMode>,
        activeRateAgreement
    );
}

const createCssLink = () => {
    // @ts-ignore inject from webpack build
    const cssFileVersion = __BUILD_VERSION_HASH__;

    // create new link tag
    const link = document.createElement("link");
    link.href = "/services/rateagreement/main.css?v=" + cssFileVersion;
    link.rel = "stylesheet";
    link.type = "text/css";

    // Loading failed
    link.onerror = function () {
        console.error("Can't load css styles for content! ");
    };

    // append link element to html
    document.body.appendChild(link);
};
createCssLink();
